module.exports = __webpack_public_path__ + "img/onboarding-portfolio-final.e4ce6f12.svg";